import { StateCreator } from "zustand";
import { SelectedChassisType } from "./api";

export interface SelectionSlice {
  selectedOfficeId: number | null;
  selectedChassisType: SelectedChassisType | null;
  geoToken: string | null;
  setSelectedOfficeId: (id: number | null) => void;
  setSelectedChassisType: (value: SelectedChassisType | null) => void;
  setGeoToken: (value: string | null) => void;
}

export const createSelectionSlice: StateCreator<SelectionSlice> = set => ({
  selectedOfficeId: null,
  selectedChassisType: null,
  geoToken: null,
  setSelectedOfficeId: selectedOfficeId => set({ selectedOfficeId }),
  setSelectedChassisType: selectedChassisType => set({ selectedChassisType }),
  setGeoToken: geoToken => set({ geoToken }),
});
